<template>
	<div v-if="!contextualLoading" class="flex-centerize">
		<SkippedContextualNodeBtn class="flex-centerize" @onClick="createActionContextNode" :placement="elementPlacement" />
	</div>
	<AppLoader v-else />
</template>
<script>
import { mapActions } from 'vuex';
import { setContextualDataState } from '@/store/modules/selectedWorkflow/actions';
import FlowTreeMixin from './FlowTreeMixin';
import SkippedContextualNodeBtn from './SkippedContextualNodeBtn.vue';
export default {
	name: 'FlowContextualActionSkippedNode',
	components: { SkippedContextualNodeBtn },
	mixins: [FlowTreeMixin],
	methods: {
		...mapActions([setContextualDataState.fullPath]),
		async createActionContextNode() {
			this.contextualLoading = true;
			try {
				await this[setContextualDataState.fullPath]({ state: true });
			} finally {
				this.contextualLoading = false;
			}
		},
	},
	data() {
		return { contextualLoading: false };
	},
};
</script>
<style scoped lang="scss"></style>
